<!--
 * @Author: zxf
 * @Date: 2022-07-20 18:18:58
 * @LastEditors: zxf
 * @LastEditTime: 2022-12-29 18:12:53
 * @Description: 检测项目查看
-->
<template>
  <el-form
    ref="fd"
    v-loading="loading"
    :inline="true"
    label-suffix="："
    :model="fd"
    label-position="right"
    label-width="160px"
    class="c-form"
  >
    <!-- 基本信息 -->
    <el-row
      class="c-form__row"
    >
      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        基础信息
      </el-col>

      <!-- <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="重点单位"
          prop="zddw"
        >
          <span class="c-form__read">{{ fd.zddw === "Y"?'是':"否" }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="签到要求"
          prop="qdyq"
        >
          <span class="c-form__read">{{ fd.qdyq === '0' ? 'GPS定位' : 'GPS定位+人脸识别' }}</span>
        </el-form-item>
      </el-col> -->
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="项目名称"
          prop="xmmc"
        >
          <span class="c-form__read">{{ fd.xmmc }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="所属区域"
          prop="areaMc"
        >
          <span class="c-form__read">{{ fd.areaMc }} </span>
        </el-form-item>
      </el-col>

      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="项目地址"
          prop="xmdz"
        >
          <span class="c-form__read">{{ fd.xmdz }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="项目概况"
          prop="xmgk"
        >
          <textarea-read v-model="fd.xmgs" />
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="联系人"
          prop="lxr"
        >
          <span class="c-form__read">{{ fd.lxr }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="联系电话"
          prop="lxdh"
        >
          <span class="c-form__read">{{ fd.lxdh }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="委托单位"
          prop="wtdw"
        >
          <span class="c-form__read">{{ fd.wtdw }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="统一社会信用代码"
          prop="shxydm"
        >
          <span class="c-form__read">{{ fd.shxydm }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="设计单位"
          prop="sjdw"
        >
          <span class="c-form__read">{{ fd.sjdw }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="施工单位(维保单位)"
          prop="sgdw"
        >
          <span class="c-form__read">{{ fd.sgdw }}</span>
        </el-form-item>
      </el-col>
      <!-- <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              合同信息
            </el-col> -->
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="合同名称"
          prop="htmc"
        >
          <span class="c-form__read">{{ fd.htmc }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="合同金额（元）"
          prop="htje"
        >
          <span class="c-form__read">{{ fd.htje }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="合同扫描件"
          prop="htFileId"
        >
          <file-list
            v-model="fd.htFileId"
            disabled
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="检测方案"
          prop="jcfaFileId"
        >
          <file-list
            v-model="fd.jcfaFileId"
            disabled
          />
        </el-form-item>
      </el-col>

      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="检测内容"
          prop="  jcnrList"
        >
          <span
            v-for="(item,index) in fd.jcnrList"
            :key="`xfjcInfo-${index}`"
          >
            {{ index + 1 }}、{{ item.jcnrMc }} ；

          </span>
        </el-form-item>
      </el-col>
      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="检测依据"
          prop="jcyj"
        >
          <textarea-read
            v-model="fd.jcyj"
            class="c-form__read u-line-20"
          />
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="检测日期"
          prop="jcrqQZ"
        >
          <span class="c-form__read">{{ fd.jcrqq || '-' | date("yyyy-MM-dd ") }}</span> 至 <span class="c-form__read">{{ fd.jcrqz|| '-' | date("yyyy-MM-dd ") }}</span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col c-form__placeholder"
        :span="12"
      />
      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="消防批文"
          prop="xfpw"
        >
          <textarea-read
            v-model="fd.xfpw"
            class="c-form__read u-line-20"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="项目负责人"
          prop="xmfzrMc"
        >
          <span class="c-form__read">{{ fd.xmfzrMc }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="审核人"
          prop="shrMc"
        >
          <span class="c-form__read">{{ fd.shrMc }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="现场检测员"
          prop="xcjcyDm"
        >
          <span
            v-for="(item,index) in fd.xcjcyDm"
            :key="`xfjcInfo-${index}`"
          >
            {{ item.cyMc }} &nbsp;</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="批准人（签章）"
          prop="sprMc"
        >
          <span class="c-form__read">{{ fd.sprMc }}</span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        检测建筑物概况
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="竣工日期"
          prop="jgrq"
        >
          <span class="c-form__read">{{ fd.jgrq || '-' | date("yyyy-MM-dd ") }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="竣工图纸提供情况"
          prop="jgtztgqk"
        >
          <span class="c-form__read">{{ fd.jgtztgqk }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="建筑总面积（m²）"
          prop="jzmj"
        >
          <span class="c-form__read">{{ fd.jzmj }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="检测面积（m²）"
          prop="jcmj"
        >
          <span class="c-form__read">{{ fd.jcmj }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="建筑类别"
          prop="jzlbMc"
        >
          <span class="c-form__read">{{ fd.jzlbMc }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="建筑楼层/建筑高度"
          prop="jzlc"
        >
          <span class="c-form__read">{{ fd.jzlc }}</span>
        </el-form-item>
      </el-col>
      <!-- <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="建筑高度（m）"
          prop="jzgd"
        >
          <span class="c-form__read">{{ fd.jzgd }}</span>
        </el-form-item>
      </el-col> -->
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="检测类型"
          prop="jclx"
        >
          <span class="c-form__read">{{ fd.jclxMc }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="检测范围"
          prop="jcfwMc"
        >
          <span class="c-form__read">{{ fd.jcfwMc }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="检测部位"
          prop="jcbw"
        >
          <span class="c-form__read">{{ fd.jcbw }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="使用功能"
          prop="sygn"
        >
          <span class="c-form__read">{{ fd.sygn }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { xmglService } from '../xmgl.service';
import config from '@/config.js';
export default {
  name: 'ViewJcxm',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading状态
      xmId: '', // 数据ID
      xmfzrList: [], // 项目负责人列表
      shrList: [], // 审核人列表
      pzrList: [], // 批准人列表
      jcxBtnName: '',
      xcjcyList: [], // 现场检测员
      // fireEngineerList: '', // 批准人
      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 End */

      /* 申请信息 Start */
      fd: {
        xmmc: null,
        zddwBz: null,
        qdyq: null,
        ssqyDm: null,
        xmdz: null,
        lxr: null,
        lxdh: null,
        wtdw: null,
        shxydm: null,
        sjdw: null,
        sgdw: null,
        htmc: null,
        htje: null,
        htFileId: null,
        xmgk: null,
        xfpw: null,
        jcyj: '《建筑防火及消防设施检测技术规程》DBJ/T 15-110-2015',
        jcnrList: [],
        jcfaFileId: null,
        jcrqq: null,
        jcrqz: null,
        jcrqQZ: [null, null],
        xmfzr: null,
        shr: null,
        xcjcy: [],
        pzr: null,
        jgrq: null,
        jgtztgqk: null,
        jzmj: null,
        jcmj: null,
        jzlbMc: null,
        jzlc: null,
        jzgd: null,
        jzlx: null,
        jcfwMc: null,
        jcbw: null,
        sygn: null,
        qdxxList: [{
          qdsj: null,
          qdr: null,
          qddd: null
        }],
        wjcs: 0,
        yjcs: 0,
        jcxzs: 0,
        jccs: 0,
        jcbgdz: null,
        bgbh: null,
        jcjl: null

      },
      /* 申请信息 End */

      /* 文件服务器对接参数 Start */
      headers: { // 请求头部配置
        [config.serverHeaderTokenName]: this.$HMCookies.get(config.serverHeaderTokenName)
      },
      prepareUrl: config.prepareUrl, // 上传预加载服务地址
      uploadUrl: config.uploadUrl, // 上传服务地址
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'htwj',
            value: null
          }
        ]
      }
      /* 文件服务器对接参数 END */
    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlType () {
      return this.$route.params.type;
    }
  },
  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },

    /**
     * @description: 签章
     * @return {*}
     */
    handleQz () {
      const _this = this;
      _this.$confirm('是否确认签章？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        xmglService.qz(_this.xmId)
          .then(rsp => {
            _this.$alert('签章成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {

              }
            });
          })
          .catch(err => {
            console.error('签章失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },

    /**
     * @description: 生成报告
     * @return {*}
     */
    handleScbg () {
      const _this = this;
      _this.$confirm('是否确认生成报告？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        xmglService.scbg(_this.xmId)
          .then(rsp => {
            _this.$alert('报告生成成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                _this.isNeedQzShow = true;
              }
            });
          })
          .catch(err => {
            console.error('报告生成失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 加盖公章
     * @return {*}
     */
    handleJggz () {
      const _this = this;
      _this.$confirm('是否确认加盖公章？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        xmglService.jggz(_this.xmId)
          .then(rsp => {
            _this.$alert('加盖公章成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                _this.isNeedQzShow = true;
              }
            });
          })
          .catch(err => {
            console.error('加盖公章失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },

    /**
     * @description: 重新评估
     * @return {*}
     */
    handleCxpg () {
      const _this = this;
      _this.$confirm('是否确认重新检测？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        xmglService.jggz(_this.xmId)
          .then(rsp => {
            _this.$alert('设置成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                _this.isNeedQzShow = true;
              }
            });
            _this.closeNavTabAndTo({ name: 'editJcxm', params: { xmId: _this.xmid } }, true);
          })
          .catch(err => {
            console.error('设置失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },

    /**
     * @description: 界面初始化
     * @return {*}
     */
    init () {
      this.loading = true;
      // 编辑模式初始化
      xmglService.getInfo(this.xmId)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);

          this.$emit('updateXminfo', this.fd);
        })
        .catch(err => {
          console.error('获取检测项目信息失败！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    // 获取路由的数据ID
    this.xmId = this.$route.params.xmId;
    this.init();
  }

};
</script>
